import React, { useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { popUpMenuChange, toggleSwitch } from '../../actions/index';

import Icon from '@mdi/react';
import { mdiTextBoxPlusOutline } from '@mdi/js';

import { _ } from '../../functions/translator';
import { ToggleActions } from '../../constants/constants';

const AddRegisterButton = (props) => {
    const buttonRef = useRef(null);

    const handleClick = () => {
        props.toggleSwitch(ToggleActions.ADD_NEW_REGISTER, {show: true, value: props.properties});
        props.popUpMenuChange({ show: false });
    };

    let buttonName = ''
    if(props.properties.name) {
        buttonName = props.properties.name
    }

    return (
        <div>
            <div className="popup-menu-button card-color" ref={buttonRef} onClick={handleClick}>
                <div className='w-100 d-inline-flex'>
                    <Icon path={mdiTextBoxPlusOutline} size='30px' color='white' style={{ margin: 10 }} />
                    <div className='w-100 m-0 d-flex justify-content-center flex-column'>
                        <p style={{wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal'}} 
                        className='m-0'>{_('Agregar')} {buttonName}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        popUpMenu: state.popUpMenu,
        selectedCardsGroups: state.selectedCardsGroups,
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        popUpMenuChange: popUpMenuChange,
        toggleSwitch: toggleSwitch,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(AddRegisterButton);
